import React from 'react';
import {
  notifica,
  getUser,
  show_mdl_ldr
} from "../requests/utils";
import ReactDOM from 'react-dom';
import Countdown from 'react-countdown';
import {isMobile} from 'react-device-detect';
import api from '../service/api';
const videoType = 'video/webm;codecs="h264"';

const sleep = (milliseconds) => {
  return new Promise(resolve => setTimeout(resolve, milliseconds))
}

export default class Vios extends React.Component {
  constructor(props) {
    super(props);
    this.startRecording = this.startRecording.bind(this);
    this.stopRecording = this.stopRecording.bind(this);
    this.saveVideo = this.saveVideo.bind(this);
    this.onChangeOrientation = this.onChangeOrientation.bind(this);
    this.stop = this.stop.bind(this);
    this.state = {
      recording: false,
      videos: [],
      mimes: [],
      timeLimit: this.props.timeLimit !== undefined ? this.props.timeLimit : 90000,
      min: 0,
      seg: 0,
      lbltimer: '00:00',
      px: '100%',
      wpx: '100%'
    };
  }

  async componentDidMount() {
    try {
      if (isMobile) {
        window.addEventListener('orentationchange', this.onChangeOrientation);
      }

      const stream = await navigator.mediaDevices.getUserMedia({ video: "user", audio: true });
      this.video.srcObject = stream;
      this.video.play();
      this.mediaRecorder = new MediaRecorder(stream, {
        mimeType: videoType,
      });

      // init data storage for video chunks
      this.chunks = [];
      // listen for data from media recorder
      this.mediaRecorder.ondataavailable = e => {
        // this.chunks.push(e.data);
        if (e.data && e.data.size > 0) {
          this.chunks.push(e.data);
        }
      };
      this.mediaRecorder.onstop = e => {
        try {
          var bodyFormData = new FormData(),
            lbl = document.getElementById("lbl_pregunta_p_video"),
            idPregunta = lbl.getAttribute("IDPregunta"),
            lbl2 = document.getElementById("lbl_pregunta_tipo"),
            tipo = lbl2.getAttribute("tipo"),
            lbl3 = document.getElementById("lbl_pregunta_sol"),
            idSolicitud = lbl3.getAttribute("sol"),
            usr = getUser(),
            url = "",
            json = "",
            name = "";

          if (tipo === "TC") {
            url = "PreguntasTecnicas/pregunta-tecnica-detalle";
            json = {
              idCandidato: usr.idCandidato,
              idPregunta: idPregunta,
              idSolicitud: idSolicitud
            };
            bodyFormData.set("idCandidato", usr.idCandidato);
            bodyFormData.set("idPregunta", idPregunta);
            bodyFormData.set("idSolicitud", idSolicitud);
            name = `VideoTecnicas${usr.idCandidato}${idPregunta}`;
          } else {
            url = "estudiopsicometrico/archivo";
            json = { idCandidato: usr.idCandidato, idPregunta: idPregunta };
            name = `VideoRH${usr.idCandidato}${idPregunta}`;
            bodyFormData.set("idCandidato", usr.idCandidato);
            bodyFormData.set("idPregunta", idPregunta);
          };
          let file = new File(this.chunks, `${name}.mp4`, { type: "video/mp4" });
          bodyFormData.set("archivo", file);
          show_mdl_ldr(true);
          var vd = document.getElementById("btninitV");
          if (vd)
            vd.classList.add("Hide_Half");
          api.post(url, bodyFormData, {
            headers: {
              "Content-Type": "multipart/form-data",
              "X-Requested-With": "XMLHttpRequest"
            }
          })
          .then(function (response) {
            show_mdl_ldr(false);
              if (response.data.code === 0) {
                var btn = document.getElementById("btn_grdvideo_sigue");
                btn.classList.remove("Hide_Half");

                notifica("sucess", "Se guardo Correctamente", "¡Corrrecto!");
              } else {
                document.getElementById("btnModalClose").hidden = false;
                notifica("error", response.data.message, "¡Error!");
              }
            })
            .catch(function (error) {
            });
        } catch (err) {
          alert(err)
        }
      };


    }
    catch (err) {
      alert(err);
    }
  }
  componentWillUnmount() {
    if (isMobile)
      window.removeEventListener('orentationchange', this.onChangeOrientation);
  }
  onChangeOrientation(e) {
    if (e !== null && e !== undefined)
      e.target.screen.lockOrientation("portrait-primary");
  }
  startRecording(e) {
    e.preventDefault();
    const { timeLimit } = this.state;
    this.chunks = [];
    this.mediaRecorder.start(10);

    this.setState({ recording: true });
    sleep(timeLimit).then(() => {
      this.stop();
    });

    ReactDOM.render(
      <Countdown date={Date.now() + timeLimit} />,
      document.getElementById('timer')
    );


  }
  stop() {
    this.mediaRecorder.stop();
    this.setState({ recording: false });
  }

  stopRecording(e) {
    e.preventDefault();
    this.mediaRecorder.stop();
    this.setState({ recording: false });
  }

  saveVideo() {
    try {
      // convert saved chunks to blob
      const blob = new Blob(this.chunks, { type: videoType });
      // generate video url from blob
      const videoURL = window.URL.createObjectURL(blob);
      // append videoURL to list of saved videos for rendering
      const videos = this.state.videos.concat([videoURL]);
      this.setState({ videos });
    } catch (err) {
      alert(err)
    }
  }
  render() {
    const { recording, px, wpx } = this.state;
    return (
      <div className="camera">
        <div id="timer" name="timer"></div>
        <video
          style={{
            width: wpx, height: px
            , display: recording ? '' : 'none'
          }}
          ref={v => {
            this.video = v;
          }}
          playsInline
        >
          Video no dispobible.
        </video>
        <div style={{ display: !recording ? '' : 'none', width: '100%', height: '300px' }}>
          {!recording && <button className="form-control" style={{ display: 'block', margin: '0 auto' }} onClick={e => this.startRecording(e)}>Clic aqui para iniciar grabación</button>}
        </div>

      </div>
    );
  }




}